<template>
    <div id="bp-copyright" class="container-fluid">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-6 float-start align-items-start d-flex flex-column justify-content-center text-start copyright-content">
                    <ul class="list-group list-group-horizontal align-items-center bp-list-group">
                        <li class="list-group-item">
                            <i class="fa-regular fa-copyright"></i>
                            <span class="copyright-year">
                                <!-- <script>document.write(new Date().getFullYear())</script> -->
                                {{ client.name }}
                            </span>
                        </li>
                        <li class="list-group-item privacy-link">
                            <router-link to="/privacy">Privacy Policy</router-link>
                        </li>
                    </ul>
                </div>
                <div class="col-12 col-lg-6 float-end d-flex align-items-center justify-content-end text-end builtBy-content">
                    <p>
                        Crafted from the 
                        <span class="pulse-animation">
                            <i class="far fa-heart"></i>
                            <i class="fas fa-heart"></i>
                        </span>
                         of design by 
                        <a href="https://builtbypurpose.au" target="_blank">
                            <b>{{ developer.name }}</b>
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
   export default ( {
        name: "copyright",
        data() {
            return {
                client: {
                    name: "2022 Bellingen Property"
                },
                developer: {
                    name: "Built by Purpose"
                }
            }
        }
   });
</script>

<style lang="scss" scoped >

    // global vars
    @import "../../scss/vars.one3design.scss";

    // global mixins
    @import "../../scss/mixins.one3design.scss";

    @keyframes pulse-outline {
        0% { opacity: 1; transform: scale(.9); }
        50% { opacity: 0; transform: scale(1.15); }
        100% { opacity: 1; transform: scale(.9); }
    }

    @keyframes pulse-solid {
        0% { opacity: 0; transform: scale(1); }
        50% { opacity: 1; transform: scale(1.15); }
        100% { opacity: 0; transform: scale(1); }
    }

    #bp-copyright {
        background-color: #002532;
        border-top: 1px solid #58595b;
        position: relative;
        .copyright-content {
            min-height: 100px;
            .bp-list-group {
                .list-group-item {
                    background-color: transparent;
                    border: 0;
                    color:lighten( $text, 15% );
                    max-height: 35px;
                    padding:0;
                }
                .privacy-link {
                    margin-left: 1.5em;
                    padding-left: 1.5em;
                    position: relative;
                    &:before {
                        content: '';
                        background-color: lighten( $text, 15% );
                        height: 1em;
                        left: 0;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 1px;
                    }
                    a {
                        @include animation( all, .3s, ease-in-out );
                        color: lighten( $text, 15% );
                        text-decoration: none;
                        &:hover {
                            color: $color_main;
                        }
                    }
                }
            }

        }
        .builtBy-content {
            color:lighten( $text, 15% );
            p {
                margin:0;
            }
            .pulse-animation {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                position: relative;
                width: 1em;
                height: 1em;
                svg, i {
                    position: absolute;
                    animation-duration: 1.5s;
                    animation-iteration-count: infinite;
                }
                .far, svg[data-prefix=far] {
                    animation-name: pulse-outline;
                    color: $color_base;
                }
                .fas, svg[data-prefix=fas] {
                    animation-name: pulse-solid;
                    color: $color_main;
                }
            }
            a {
                @include animation( all, .3s, ease-in-out );
                color:inherit;
                font-weight:$font-weight-bold;
                text-decoration:none;
                &:hover {
                    color:$color_main;
                }
            }
        }

        @media screen and ( max-width: $mobile ) {
            .copyright-content {
                min-height: 1px;
                padding: 1rem;
                .bp-list-group {
                    align-items:center;
                    display: flex;
                    flex-direction:column;
                    justify-content:center;
                    text-align:center;
                    width:100%;
                    .privacy-link {
                        margin-left: 0;
                        margin-top: .5em;
                        padding-left: 0;
                        &:before {
                            display: none;
                        }
                    }
                }
            }
            .builtBy-content {
                align-items:center;
                display: flex;
                flex-direction:column;
                justify-content:center;
                min-height: 1px;
                padding:1em;
                text-align:center;
            }
        }
    }

</style>